import { render, staticRenderFns } from "./Page-Webamp.vue?vue&type=template&id=cb67b2e8&"
import script from "./Page-Webamp.vue?vue&type=script&lang=js&"
export * from "./Page-Webamp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports